/*
 * @Author: xiaowei
 * @Date: 2018-09-07 16:47:09
 * @Last Modified by: xiaowei
 * @Last Modified time: 2019-05-29 10:49:51
 */

<template>
  <div class="weathermap">
    <div class="map" :id="id"></div>
  </div>
</template>

<script>
  // 引入WeatherMap资源
  import './config'
  import './Layers/TianDiTuLayer'
  import WeatherMap from 'weathermap'

  const { Map, Layer, Control } = WeatherMap;


  export default {
    name: 'weathermap',
    props: {
      id: {
        type: String,
        default: 'map'
      },
      baseLayer: {
        type: String,
        default: 'Tianditu'
      },
      options: {
        type: Object,
        default () {
          return {
            centerAt: [96, 35], // 地图中心点
            zoom: 6 // 缩放级别
          }
        }
      }
    },
    watch: {
      baseLayer (lyr) {
        this.setBaseLayer(lyr)
      }
    },
    methods: {
      init () {
        if (this.map) return
        let { centerAt, zoom } = this.options
        this.map = new Map(this.id, {
          theme: null,
          controls: [
            // new Control.ScaleLine(),
            // new Control.PanZoomBar(),
            new Control.Navigation(),
            new Control.LayerSwitcher(),
            new Control.MousePosition()
          ]
        })

        this.setBaseLayer(this.baseLayer)

        this.map.setCenter(new WeatherMap.LonLat(centerAt[0], centerAt[1]), zoom)

        this.$emit('getMap',this.map)

      },
      /**
       * 切换地图底图
       * @param {String} name 底图
       *
       * @requires LocalTiledCacheLayer
       * @requires TianDiTuLayer
       */
      setBaseLayer (name) {
        let baseLyr = null
        let attr = { id: 'baseLayer', name, isBaseLayer: true }
        switch (name) {
          case 'WhiteMap':
            baseLyr = Object.assign(new Layer.LocalTiledCacheLayer(), attr)
            break
          case 'Tianditu':
            baseLyr = Object.assign(new Layer.TianDiTuLayer(), attr)
            break
          default:
            return
        }

        // 移除原底图
        let oldBaseLyr = this.map.getLayer(attr.id)
        oldBaseLyr && this.map.removeLayer(oldBaseLyr, true)
        baseLyr.wrapDateLine = true;
        // 添加新底图
        this.map.addLayer(baseLyr)
        if(name == 'Tianditu'){
            let layerLabel = new Layer.TianDiTuLayer();
            layerLabel.setFormat("cva");
            layerLabel.setName("tianDiTuLayer_cva");
            layerLabel.setIsBaseLayer(false);
            this.map.addLayer(layerLabel);
        }
        return baseLyr
      },
      refresh () {
        this.map.updateSize()
      }
    },
    created () {},
    mounted () {
      this.init()
    },
    destroyed () {
      this.map.destroy()
    }
  }

</script>

<style>
  .weathermap, .map {
    display: block;
    position: relative;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/map/weathermap.vue